export const DOC_TYPE_LABEL: Record<string, string> = {
  npa: 'НПА',
  local: 'Локальный',
  instruction: 'Инструкция',
};

export const DOC_TYPE_OPTIONS = [
  { value: 'npa', label: 'НПА' },
  { value: 'local', label: 'Локальный' },
  { value: 'instruction', label: 'Инструкция' },
] as const;

export const DOC_TYPE_FILTER_OPTIONS = [{ value: 'all', label: 'Все' }, ...DOC_TYPE_OPTIONS] as const;
